import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Services from "@/pages/Services";
import Projects from "@/pages/Projects";
import Shop from "@/pages/Shop";
import Blogs from "@/pages/Blogs";
import BlogDetail from "@/pages/BlogDetail";
import Contact from "@/pages/Contact";

function App() {
    return (
        <BrowserRouter>
            <Layout>
                <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/about" element={<About />} />
                    <Route path="/services" element={<Services />} />
                    <Route path="/projects" element={<Projects />} />
                    <Route path="/products" element={<Shop />} />
                    <Route path="/shop" element={<Navigate to="/products" replace />} />
                    <Route path="/blogs" element={<Blogs />} />
                    <Route path="/blogs/:slug" element={<BlogDetail />} />
                    <Route path="/contact" element={<Contact />} />
                </Routes>
            </Layout>
            <Toaster
                position="bottom-center"
                theme="dark"
                toastOptions={{
                    style: {
                        background: "#0F1115",
                        border: "1px solid rgba(255,255,255,0.12)",
                        color: "#fff",
                    },
                }}
            />
        </BrowserRouter>
    );
}

export default App;
